module.exports = __webpack_public_path__ + "assets/img/4.bdcdb276.svg";